
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Environment variables are required - no fallbacks to prevent wrong instance connections
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL) {
  throw new Error('VITE_SUPABASE_URL environment variable is required. Please set it in your .env file or deployment environment.');
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('VITE_SUPABASE_PUBLISHABLE_KEY environment variable is required. Please set it in your .env file or deployment environment.');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const PROJECT_REF = new URL(SUPABASE_URL).host.split('.')[0];
const STORAGE_KEY = `emu-mentoring-auth-${PROJECT_REF}`;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: STORAGE_KEY
  },
  db: {
    schema: 'public'
  }
});
